import { FlatList } from '@openx/components-core/lib/TransferList/FlatList.tsx';
import type { SeedListData } from '@openx/types/segments.ts';
import { useTranslation } from 'react-i18next';
import { SeedRenderItem } from './SeedRenderItem.tsx';
import { useHandleScroll } from './useHandleScroll.ts';

type SeedListFlatListProps = {
  listData: SeedListData[];
  handleAddItem: (item: SeedListData) => void;
  asyncSearchFn: (searchInput: string) => Promise<void>;
  itemSize: number;
  loadMore?: () => void;
  hasMore?: boolean;
  loadingMore?: boolean;
  allItemsCount?: number;
};
export const SeedListFlatList = ({
  listData,
  handleAddItem,
  asyncSearchFn,
  itemSize,
  loadMore,
  hasMore,
  loadingMore,
  allItemsCount,
}: SeedListFlatListProps) => {
  const { t } = useTranslation();
  const customEmptyText = t('Select Provider to display Segments');
  const { handleScroll } = useHandleScroll(listData, itemSize, loadMore, hasMore, loadingMore);

  return (
    <FlatList
      dataTest="seed-add-list"
      data={listData}
      handleItemRowClick={handleAddItem}
      isSelectedList={false}
      isDisabled={false}
      hasBulkInput={false}
      customEmptyText={customEmptyText}
      fullWidth={true}
      customItem={SeedRenderItem}
      isAsyncSearch={true}
      asyncSearchFn={asyncSearchFn}
      customPlaceholder={t('Search Name or ID')}
      itemSize={itemSize}
      onScroll={handleScroll}
      allItemsCount={allItemsCount}
      isInfiniteScroll={true}
    />
  );
};
